import styled from '@emotion/styled';
import { Button } from '@mui/material';
import { withStyles } from '@mui/styles';
import Theme from 'App.theme';
import { StatusTile } from 'components/StatusTile/StatusTile';

export const DraftTileButton = withStyles({
  root: {
    width: '18rem',
    height: '14rem',
    fontSize: '1rem',
    fontFamily: Theme.font,
    overflow: 'hidden',
    borderRadius: '1rem',
    backgroundColor: Theme.greys.GREY0,
    border: `2px solid ${Theme.colours.primary}`,
    '&:hover': {
      boxShadow: '2px 2px 5px 0px ' + Theme.greys.GREY1,
      backgroundColor: Theme.greys.GREY1,
    },
  },
})(Button);

export const DraftSection = styled.section`
  margin-bottom: 3rem;
`;

export const DraftTileContent = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
`;

export const DraftTileStatus = styled(StatusTile)`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  z-index: 1;
`;

export const DraftTileImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 15rem;
`;

export const DraftTileName = styled.div`
  background-color: ${Theme.colours.primary};
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: black;
  font-weight: bold;
`;
